"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contrast = void 0;
const react_1 = __importDefault(require("react"));
const Base_1 = require("../Base");
const colors = {
    minimum: '#6E6D6A',
    low: '#4F4E4C',
    medium: '#333231',
    high: '#242423',
    inverse: '#FFF',
};
const Contrast = ({ appearance = 'medium', children, ...props }) => {
    return (react_1.default.createElement(Base_1.Base, { color: colors[appearance], ...props }, children));
};
exports.Contrast = Contrast;
